import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { EmployeeSearchSchema } from './-zod-schema';

export const Route = createFileRoute('/_staff/attendances/_layout/employees/')({
  validateSearch: zodValidator(EmployeeSearchSchema),
});
